import { useEffect, useState } from 'react'
import { api } from 'roadie-ui'
import Page from 'rui/widgets/Page'
import { Helmet } from 'react-helmet'
import DriveSidebar from 'components/layout/DriveSidebar'
import { PanelSpacer } from 'components/layout/Panel'
import { StaticLoader } from 'components/misc/Loader'
import Promotions from 'components/misc/Promotions'
import { useLocalization } from 'localization'

function fetchPromotions() {
  return api
    .external()
    .get(import.meta.env.REACT_APP_ROADIE_TUTORIALS_URL)
    .then((resp) => {
      return resp.data.promotions
    })
}

const PromotionsPage = () => {
  const { t } = useLocalization()
  const [loading, setLoading] = useState(true)
  const [promotions, setPromotions] = useState(null)

  useEffect(() => {
    fetchPromotions().then((data) => {
      setPromotions(data)
      setLoading(false)
    })
  }, [])

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_layout_drive_sidebar_promotions')}</title>
      </Helmet>
      <PanelSpacer />
      {loading ? <StaticLoader /> : <Promotions data={promotions.drive} />}
    </Page>
  )
}

export default PromotionsPage
